import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    borderLeft: '1px solid rgba(0, 0, 0, 0.2)',
    background: '#fff',
    //overflow: 'hidden',
  },
  header: {
    padding: '10px 15px',
    //boxShadow: '0 0 5px rgba(74, 74, 74, 0.5)',
    borderBottom: '1px solid rgba(0, 0, 0, 0.2)',
  },
  body: {
    flex: 1,
    borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
    '& .ps__rail-x': {
      display: 'none',
    },
    '& .ps__thumb-y': {
      //minHeight: '20px',
    },
  },
  footer: {},
  icon: {
    cursor: 'pointer',
    '& svg': {
      display: 'block',
    },
  },
  item: {
    position: 'relative',
    fontSize: '0.785rem',
    marginBottom: '6px',
    borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
    '&:hover': {
      '& $item_top': {
        opacity: 1,
        transition: 'all 0.4s ease-out',
      },
    },
    '&::last-child': {
      borderBottom: 'none',
    },
  },
  item_top: {
    display: 'flex',
    justifyContent: 'start',
    opacity: '0',
    transition: 'all 0.4s ease-out',
  },
  show_more: {
    color: 'rgba(18, 117, 216, 1)',
    cursor: 'pointer',
  },
  shorcut: {
    fontWeight: 600,
    fontSize: '12px',
    color: 'rgba(0, 0, 0, 0.64)',
    border: '1px solid rgba(0, 0, 0, 0.2)',
    borderRadius: '4px',
    padding: '5px 8px',
    marginRight: '5px',
  },
  hash: {
    color: 'rgba(18, 117, 216, 1)',
  },
  description: {},
  btn: {
    color: 'rgba(18, 117, 216, 1)',
    cursor: 'pointer',
  },
  additional_info: {
    opacity: 0.5,
    fontSize: '12px',
    lineHeight: '14px',
  },
  info_name: {
    fontWeight: 600,
    color: 'rgba(0, 0, 0, 0.64)',
  },
  in_view: { position: 'absolute', bottom: '10px' },
  removeConfirmation: {
    position: 'absolute',
    zIndex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    width: '100%',
    height: '100%',
    background: 'rgba(255,255,255, 0.9)',
  },
}));
